import(/* webpackMode: "eager" */ "/root/workspace/__flow_work/__flow_builds/c234a4e8-3107-4f60-88f0-bb11aad254d6/workspace/lych-dg-pc_T57I/src/app/global-error.tsx");
